import axios from "axios";

export const getBlogs = async (pageNumber, pageSize) => {
  try {
    const response = await axios.get("/api/Content/GetBlogs", {
      params: {
        pageNumber: pageNumber ?? 1,
        pageSize: pageSize ?? 12,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getBlog = async (slug) => {
  try {
    const response = await axios.get("/api/Content/GetBlog", {
      params: {
        slug: slug,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// getPage
export const getPage = async (slug) => {
  try {
    const response = await axios.get("/api/Content/GetPage", {
      params: {
        slug: slug,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

// time formatter function  024-10-31T13:01:48+03:00 => 31 Ekim 2024 13:01 not 13:1
export const timeFormatter = (time) => {
  const date = new Date(time);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  };
  return new Intl.DateTimeFormat("tr-TR", options).format(date);
};

export const getContactInfo = async () => {
  try {
    const response = await axios.get("/api/SiteSettings/GetContactUs");
    return response.data.Payload;
  } catch (error) {
    console.error(error);
  }
};

export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(
      "/api/SiteSettings/SubmitContactForm",
      formData
    );
    return response.data.Payload;
  } catch (error) {
    console.error(error);
  }
};

export const fetchSlides = async () => {
  try {
    const response = await axios.get("/api/SiteSettings/GetAuthSliders");
    return response.data.Payload;
  } catch (error) {
    console.error(error);
  }
};

export const fetchLegalDocuments = async () => {
  try {
    const response = await axios.get("/api/SiteSettings/GetLegalDocuments");
    return response.data.Payload;
  } catch (error) {
    console.error(error);
  }
};
